// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__JnaVO","primary":"Button_primary__VIPCG","secondary":"Button_secondary__zlSfz","ghost":"Button_ghost__xcMdm"};